<template>
    <div class="question">
        <div class="right-container">
            <div class="reset-question-one" @click="resetProgressHandler(1)">
                <span>跳转回到第一题</span>
                <img src="./跳转@2x.png" alt="">
            </div>
            <div style="padding-right: 15px;">
                <questionTree :answers="questionProcess.questionTree.ANSWERS"></questionTree>
            </div>
        </div>
        <div class="question-container">
            <div style="width: 100%;position:relative;height: 100%;" v-if="showQuestion">
                <div class="common-title">{{questionProcess.question.ALL_NAME}}</div>
                <div>{{questionBaseInfo.NAME}}</div>
                
                <questionRootNode v-if="questionProcess.question.QUESTIONS && show"
                                  :question-list="questionProcess.question.QUESTIONS" :type="type"></questionRootNode>
                <div class="button-list">
                    <!-- <div class="read-only" v-if="type=='readonly'"></div> -->
                    <!--<el-popover-->
                    <!--v-model="showModel"-->
                    <!--placement="top"-->
                    <!--width="400"-->
                    <!--trigger="click">-->
                    <!--<div class="model-container">-->
                    <!--<div @click="resetProgressHandler(1)">-->
                    <!--<el-button type="primary" size="mini" style="margin-bottom: 10px;">回到第一题</el-button>-->
                    <!--</div>-->
                    <!--<questionTree :answers="questionProcess.question.ANSWERS"></questionTree>-->
                    <!--</div>-->
                    <!--<van-button slot="reference" style="width: 1.5rem;margin-right: .15rem;font-weight: 700;"-->
                    <!--type="default">问卷进程-->
                    <!--</van-button>-->
                    <!--</el-popover>-->
                    <van-button style="width: 1.5rem;font-weight: 700" @click="getNextProgress" type="info">下一页
                    </van-button>
                </div>
            </div>
            <div v-else>
                <div class="question-end-list">恭喜您，问卷已作答完毕，感谢您的配合</div>
                <div class="button-list">
                    <!--<el-popover-->
                    <!--v-model="showModel"-->
                    <!--placement="top"-->
                    <!--width="400"-->
                    <!--trigger="click">-->
                    <!--<div @click="resetProgressHandler(1)">-->
                    <!--<el-button type="primary" size="mini" style="margin-bottom: 10px;">回到第一题</el-button>-->
                    <!--</div>-->
                    <!--<div class="model-container">-->
                    <!--<questionTree :answers="questionProcess.question.ANSWERS"></questionTree>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;<van-button slot="reference" style="width: 1.5rem;margin-right: .15rem;font-weight: 700;"&ndash;&gt;-->
                    <!--&lt;!&ndash;type="default">问卷进程&ndash;&gt;-->
                    <!--&lt;!&ndash;</van-button>&ndash;&gt;-->
                    <!--</el-popover>-->
                    <!--<van-button style="width: 1.5rem;font-weight: 700" @click="getNextProgress" type="info">-->
                    <!--</van-button>-->
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import {RestZhuanBingLibraryServerGetZhuanBingLibraryToken} from "@src/assets/js/api.js";
    import Vue from 'vue'
    import {EventBus} from './event-bus'
    import {Button, Toast, Popup} from 'vant';
    import service from "@src/assets/js/api_question.js"
    import questionRootNode from '../../components/question_Third/question-root-node'
    import questionTree from '../../components/question_Third/question-tree'
    import 'vant/lib/button/style';
    import md5 from 'md5-js'

    Vue.use(Popup).use(Button)
    export default {
        name: "question",
        props: {
            taskId: {
                required: true
            },
            admitNo: {
                required: true
            },
            type: { required: false },
        },
        data() {
            return {
                showQuestion: true,
                show: true,
                showModel: false,
                currentProcessIndex: 0,
                questionBaseInfo: {},
                questionProcess: {
                    question: {},
                    questionTree: {}
                },
                userToken: {},
                user: {},
                showModelObj: {
                    show: false
                }
            }
        },
        components: {questionRootNode, questionTree},
        beforeCreate() {
            // EventBus.$on('resetProgress', (val) => {
            //     this.resetProgressHandler(val)
            // })
        },
        mounted() {
            this.initToken()
                .then(() => {
                    this.initQuestion()
                })
            // this.initQuestion()
            // console.log('问卷能否选择', this.type)

        },
        watch: {
            show: {
                handler(modelVal) {
                    if (modelVal) {
                        EventBus.$on('resetProgress', (val) => {
                            // if(!isNaN(val * 1)) {
                            //     this.resetProgressHandler(`0,${val * 1}`)
                            // }else {
                            //     this.resetProgressHandler(val)
                            // }
                            this.resetProgressHandler(val)
                        })
                    } else {
                        EventBus.$off('resetProgress')
                    }

                },
                immediate: true
            },
            // 'questionProcess.question.ANSWERS': {
            //     handler(modelVal) {
            //         if(modelVal) {
            //             EventBus.$on('resetProgress', (val) => {
            //                 // if(!isNaN(val * 1)) {
            //                 //     this.resetProgressHandler(`0,${val * 1}`)
            //                 // }else {
            //                 //     this.resetProgressHandler(val)
            //                 // }
            //                 this.resetProgressHandler(val)
            //                 EventBus.$off('resetProgress')
            //             })
            //         }else {
            //         }
            //
            //     },
            //     immediate: true
            // }
        },
        methods: {
            getContainer() {
                return document.querySelector('.question-container');
            },
            showModelHandler() {
                // this.$set('showModelObj','show',true)
            },
            initToken() {
                return new Promise((resolve, reject) => {
                    let userId = sessionStorage.getItem('userid')
                    this.user = {
                        "user": sessionStorage.getItem('userid'),
                        "time": new Date().getTime()
                    }
                    this.getLibraryTokenAsync(userId)
                        .then(res => {
                            console.log(JSON.parse(res.retValue));
                            this.userToken = JSON.parse(res.retValue).response[0].record.data[0]
                            resolve()
                        })
                })
            },
            initQuestion() {
                this.showQuestion = true
                this.questionProcess.question = {}
                let questionBaseInfo = JSON.parse(localStorage.getItem('questionBaseInfo')) || []
                let currentBaseInfo
                if (questionBaseInfo.length) {
                    currentBaseInfo = questionBaseInfo.find(item => item.NO === this.admitNo)
                    this.questionBaseInfo = [currentBaseInfo]
                } else {
                    currentBaseInfo = null
                }
                if (currentBaseInfo) {
                    this.saveQuestionProgress({UID: this.questionBaseInfo[0].UID})
                        .catch(() => {
                        })
                } else {
                    this.startAnswerAsync({
                        task: this.taskId,
                        no: this.admitNo
                    })
                        .then(res => {
                            this.questionBaseInfo = res
                            questionBaseInfo.push(res[0])
                            localStorage.setItem('questionBaseInfo', JSON.stringify(questionBaseInfo))
                            this.saveQuestionProgress({UID: res[0].UID})
                                .catch(() => {
                                    Toast('error')
                                })
                        })
                }
                this.show = true
            },
            initQuestionAsync(data) {
                let check = this.getCheckHandler([
                    {
                        "call": {
                            "type": "questionnaire",
                            "function": "create_process",
                            "format": 1,
                            "object": true, //data中的字段是否返回对象，缺省为false
                            "data": data
                        }
                    }
                ])
                return new Promise(resolve => {
                    service.requestAjax({
                        url: 'https://sdd.test.huidr.com/sdd/api',
                        method: 'POST',
                        data: {
                            "request": [
                                {
                                    "call": {
                                        "type": "questionnaire",
                                        "function": "create_process",
                                        "format": 1,
                                        "object": true, //data中的字段是否返回对象，缺省为false
                                        "data": data
                                    }
                                }
                            ],
                            user: check.user,
                            check: check.check
                            // "user": this.user,
                            // "check":{
                            //     "code": md5(`${this.user.user}${this.user.time}${this.userToken}${JSON.stringify([
                            //         {
                            //             "call": {
                            //                 "type": "questionnaire",
                            //                 "function": "create_process",
                            //                 "format": 1,
                            //                 "object": true, //data中的字段是否返回对象，缺省为false
                            //                 "data": data
                            //             }
                            //         }
                            //     ])}`)
                            // }
                        }
                    })
                        .then(res => {
                            let result = res.data.response
                            if (result.length && result.length == 1) {
                                resolve(result[0].record.data)
                            }
                        })
                })
            },
            getCheckHandler(req) {
                let string = md5(`${this.user.user}${this.user.time}${this.userToken.TOKEN}${JSON.stringify(req)}`)
                console.log(`${this.user.user}${this.user.time}${this.userToken.TOKEN}${JSON.stringify(req)}`, string);
                return {
                    "user": this.user,
                    "check": {
                        "code": string
                    }
                }
            },
            saveQuestionProgressNotJump(data) {
                return new Promise((resolve, reject) => {
                    this.saveQuestionProgressAsync(data)
                        .then(res => {
                            this.questionProcess.question = {} //防止报错infinite
                            this.questionProcess.questionTree = res
                            resolve()
                        })
                        .catch(res => {
                            reject()
                        })
                })
            },
            saveQuestionProgress(data) {
                return new Promise((resolve, reject) => {
                    this.saveQuestionProgressAsync(data)
                        .then(res => {
                            this.questionProcess.question = {} //防止报错infinite
                            if (res.STATUS === 3) {
                                // this.showQuestion = false
                            }
                            this.questionProcess.question = res
                            this.questionProcess.questionTree = res
                            resolve()
                        })
                        .catch(res => {
                            reject()
                        })
                })
            },
            resetProgressHandler(data) {
                console.log(data, this.questionProcess.question.ALL_NOW);
                if (data === this.questionProcess.question.ALL_NOW) {
                    return
                }
                this.show = false

                //===========加入保存当前页的题目
                let answerQ = []
                console.log('question=======>', this.questionProcess.question.QUESTIONS);
                if(!this.questionProcess.question['QUESTIONS']) {
                    answerQ.push([])
                }else {
                    this.questionProcess.question.QUESTIONS.forEach(it => {
                        if (it.hasOwnProperty('value')) {
                            if (it.value[0].input || it.value[0].choose) {
                                answerQ.push(it.value)
                            } else {
                                answerQ.push([])
                            }
                        } else {
                            answerQ.push([])
                        }
                    })
                }

                console.log(answerQ);
                this.saveQuestionProgressNotJump({
                    UID: this.questionBaseInfo[0].UID,
                    answer: answerQ
                })
                    .then(() => {
                        this.resetQuestionProgressAsync({
                            UID: this.questionBaseInfo[0].UID,
                            pos: data
                        })
                            .then(res => {
                                if (res.result) {
                                    this.initQuestion()
                                }else {
                                    this.$message('重置失败')
                                    this.show = true
                                }
                            })
                    })
                    .catch(() => {
                        Toast('题目未填写')
                        // this.initQuestion()
                    })
                //=================
                // setTimeout(() => {

                // }, 300)
            },
            saveQuestionProgressAsync(data) {
                let check = this.getCheckHandler([
                    {
                        "call": {
                            "type": "questionnaire",
                            "function": "answer_process",
                            "object": true,//data中的字段是否返回对象，缺省为false
                            "data": data
                        }
                    }
                ])
                return new Promise((resolve, reject) => {
                    service.requestAjax({
                        url: 'https://sdd.test.huidr.com/sdd/api',
                        method: 'POST',
                        data: {
                            "request": [
                                {
                                    "call": {
                                        "type": "questionnaire",
                                        "function": "answer_process",
                                        "object": true,//data中的字段是否返回对象，缺省为false
                                        "data": data
                                    }
                                }
                            ],
                            user: check.user,
                            check: check.check
                        }
                    })
                        .then(res => {
                            let result = res.data.response
                            if (result.length && result.length == 1) {
                                resolve(result[0].record.data[0])
                            }
                        })
                        .catch(res => {
                            reject()
                        })
                })
            },
            //初始化进程
            resetQuestionProgressAsync(data) {
                let check = this.getCheckHandler([
                    {
                        "call": {
                            "type": "questionnaire",
                            "function": "reset_process",
                            "object": true,//data中的字段是否返回对象，缺省为false
                            "data": data
                        }
                    }
                ])
                return new Promise(resolve => {
                    service.requestAjax({
                        url: 'https://sdd.test.huidr.com/sdd/api',
                        method: 'POST',
                        data: {
                            "request": [
                                {
                                    "call": {
                                        "type": "questionnaire",
                                        "function": "reset_process",
                                        "object": true,//data中的字段是否返回对象，缺省为false
                                        "data": data
                                    }
                                }
                            ],
                            user: check.user,
                            check: check.check
                        }
                    })
                        .then(res => {
                            let result = res.data.response
                            if (result.length && result.length == 1) {
                                resolve(result[0])
                            }
                        })
                        .catch(res => {
                            console.log('error')
                        })
                })
            },
            //填写答案
            getNextProgress() {
                let answerQ = []
                this.questionProcess.question.QUESTIONS.forEach(it => {
                    answerQ.push(it.value)
                })
                console.log(answerQ);
                this.saveQuestionProgress({
                    UID: this.questionBaseInfo[0].UID,
                    answer: answerQ
                })
                    .then(() => {
                        this.currentProcessIndex++
                        this.show = false
                        setTimeout(() => {
                            this.show = true
                        }, 100)
                    })
                    .catch(() => {
                        Toast('题目未填写')
                        // this.initQuestion()
                    })

            },
            //获取专病库token
            async getLibraryTokenAsync(userId) {
                let request = new RestZhuanBingLibraryServerGetZhuanBingLibraryToken()
                request.p_userId = userId
                await request.send()
                return request.result
            },
            async startAnswerAsync(data) {
                let check = this.getCheckHandler([
                    {
                        "call": {
                            "type": "questionnaire",
                            "function": "start_answer",
                            "format": 2,
                            "object": true,//data中的字段是否返回对象，缺省为false
                            "data": data
                        }
                    }
                ])
                return new Promise((resolve, reject) => {
                    service.requestAjax({
                        url: 'https://sdd.test.huidr.com/sdd/api',
                        method: 'POST',
                        data: {
                            "request": [
                                {
                                    "call": {
                                        "type": "questionnaire",
                                        "function": "start_answer",
                                        "format": 2,
                                        "object": true,//data中的字段是否返回对象，缺省为false
                                        "data": data
                                    }
                                }
                            ],
                            user: check.user,
                            check: check.check
                        }
                    })
                        .then(res => {
                            let result = res.data.response
                            if (result.length && result.length == 1) {
                                resolve(result[0].record.data)
                            }
                        })
                        .catch(res => {
                            console.log('error')
                        })
                })
            }
        }
    }
</script>

<style lang="scss">
    .common-title {
        border-left: 4px solid #248cfa;
        text-align: left;
        padding: 0 .20rem;
        margin-top: .24rem;
        font-size: .16rem;
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .model-container {
        height: 600px;
        overflow: auto;
        padding: .24rem 0;
    }

    .question {
        height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .right-container {
            min-width: 260px !important;
            height: 100%;
            overflow: auto;

            .reset-question-one {
                width: 100%;
                height: 50px;
                line-height: 50px;
                background-color: #306AF1;
                color: #fff;
                margin-bottom: 15px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: space-around;

                img {
                    width: 20px;
                }
            }
        }
    }

    .question-container {
        height: 100%;
        position: relative;
        width: 100%;
        .read-only {
                     position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.1);
                    z-index: 99;
                }

        .progress {
            padding: .15rem .15rem 0 .15rem;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .progress-item {
                width: .12rem;
                height: .12rem;
                font-size: .12rem;
                border: 1px solid #248cfa;
                padding: .04rem;
                border-radius: 50%;

                &.active {
                    background-color: #248cfa;
                    color: #fff;
                }
            }
        }


        .question-end-list {

        }

    }

    .button-list {
        padding: .15rem 0;
        box-shadow: -3px 1px 4px 3px #ccc;
        width: 100%;
        background-color: #fff;
        position: absolute;
        bottom: 0;
        left: 0;
    }

    .question-root-node {
        .question-item {
            padding: .24rem 0 .24rem 0;
            border-bottom: 1px dashed #ccc;

            .question-title {
                font-size: .16rem;
            }
        }
    }


</style>